// @ts-nocheck
import store from '@/store';
import { handleError } from '@/utilities';

export function refreshSession() {
  const { config } = store;
  let intervalId;

  function clearRefresh() {
    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function setRefresh() {
    clearRefresh();
    intervalId = window.setInterval(() => {
      store.refreshSession();
    }, config.sessionRefreshInterval);
  }
  setRefresh();

  function handleFocus() {
    store.refreshSession();
    setRefresh();
  }
  try {
    window.removeEventListener('focus', handleFocus);
    window.addEventListener('focus', handleFocus);

    window.removeEventListener('blur', clearRefresh);
    window.addEventListener('blur', clearRefresh);
  } catch (err) {
    handleError(err);
  }
}
